/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateOrganizationPaymentAddonUserOptionResponseData,
  UpdateOrganizationPaymentAddonUserOptionResponseDataFromJSON,
  UpdateOrganizationPaymentAddonUserOptionResponseDataFromJSONTyped,
  UpdateOrganizationPaymentAddonUserOptionResponseDataToJSON
} from './UpdateOrganizationPaymentAddonUserOptionResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationPaymentAddonUserOptionResponse
 */
export interface UpdateOrganizationPaymentAddonUserOptionResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationPaymentAddonUserOptionResponse
   */
  status: number
  /**
   *
   * @type {UpdateOrganizationPaymentAddonUserOptionResponseData}
   * @memberof UpdateOrganizationPaymentAddonUserOptionResponse
   */
  data: UpdateOrganizationPaymentAddonUserOptionResponseData
}

export function UpdateOrganizationPaymentAddonUserOptionResponseFromJSON(
  json: any
): UpdateOrganizationPaymentAddonUserOptionResponse {
  return UpdateOrganizationPaymentAddonUserOptionResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationPaymentAddonUserOptionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationPaymentAddonUserOptionResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: UpdateOrganizationPaymentAddonUserOptionResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationPaymentAddonUserOptionResponseToJSON(
  value?: UpdateOrganizationPaymentAddonUserOptionResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: UpdateOrganizationPaymentAddonUserOptionResponseDataToJSON(value.data)
  }
}
